export default "__VITE_ASSET__e7492afa__"